import React from 'react';
import { ArrowCircleLeftIcon as HeroArrowCircleLeftIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type ArrowCircleLeftIconProps = Omit<IconProps, 'children'>;

export const ArrowCircleLeftIcon: React.FC<ArrowCircleLeftIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroArrowCircleLeftIcon />
        </Icon>
    );
};
